import { GUIDE_HUB_PATH, LIST_PATHS } from '@/router/config';
import { Link, useLocation } from 'react-router-dom';

const FOOTER_HIDDEN_ALL_PATHS: readonly string[] = [
];

const FOOTER_HIDDEN_ALL_PATH_PATTERNS = [
] as const;

const FOOTER_HIDDEN_MOBILE_TABLET_PATHS: readonly string[] = [
];

const FOOTER_HIDDEN_MOBILE_TABLET_PATH_PATTERNS = [
  /^\/detail\/[^/]+(?:\/.*)?$/,
] as const;

export default function Footer() {
  const { pathname } = useLocation();
  const shouldHideAllFooter =
    FOOTER_HIDDEN_ALL_PATHS.includes(pathname) ||
    FOOTER_HIDDEN_ALL_PATH_PATTERNS.some((pattern) => pattern.test(pathname));
  const shouldHideMobileTabletFooter =
    FOOTER_HIDDEN_MOBILE_TABLET_PATHS.includes(pathname) ||
    FOOTER_HIDDEN_MOBILE_TABLET_PATH_PATTERNS.some((pattern) => pattern.test(pathname));

  if (shouldHideAllFooter) {
    return null;
  }

  return (
    <footer className="bg-white border-t border-[rgba(112,115,124,0.16)]">
      <div className={`${shouldHideMobileTabletFooter ? 'hidden' : 'md:hidden'} px-5 py-8`}>
        <Link to="/" className="inline-flex items-center mb-3 cursor-pointer">
          <img src='/resources/images/directwedding-logo.svg' style={{height: 40}} />
        </Link>

        <p className="m-0 text-[12px] leading-[1.65] text-[rgba(46,47,51,0.58)]">
          실제 후기와 사진을 바탕으로 예복·예물·한복 업체 정보를 정리합니다.
        </p>

        <div className="mt-5 grid grid-cols-2 gap-x-5 gap-y-2.5">
          <Link to={LIST_PATHS.SUIT} className="text-[13px] font-medium text-[rgba(46,47,51,0.72)] cursor-pointer">
            예복
          </Link>
          <Link to={LIST_PATHS.JEWELRY} className="text-[13px] font-medium text-[rgba(46,47,51,0.72)] cursor-pointer">
            예물
          </Link>
          <Link to={LIST_PATHS.HANBOK} className="text-[13px] font-medium text-[rgba(46,47,51,0.72)] cursor-pointer">
            한복
          </Link>
          <Link to={GUIDE_HUB_PATH} className="text-[13px] font-medium text-[rgba(46,47,51,0.72)] cursor-pointer">
            내 취향 찾기
          </Link>
        </div>

        <div className="mt-6 flex items-center gap-4">
          <Link
            to="/terms/privacy"
            className="text-[12px] font-medium text-[#17171A] underline-offset-2 hover:underline cursor-pointer"
          >
            개인정보처리방침
          </Link>
          <Link
            to="/terms/user-term"
            className="text-[12px] text-[rgba(46,47,51,0.58)] underline-offset-2 hover:underline cursor-pointer"
          >
            이용약관
          </Link>
        </div>

        <div className="mt-5 border-t border-[rgba(112,115,124,0.12)] pt-5 text-[11px] leading-[1.65] text-[rgba(46,47,51,0.46)]">
          <p className="m-0 font-medium text-[rgba(46,47,51,0.58)]">(주)다이렉트컴즈</p>
          <p className="m-0 mt-1">서울특별시 강남구 도산대로 221 동남빌딩 8층</p>
          <p className="m-0">사업자등록번호 261-81-13735</p>
          <p className="m-0">대표전화 1666-8639 · 팩스 02-547-4392</p>
          <p className="m-0 mt-4 text-[10.5px] text-[rgba(55,56,60,0.34)]">
            © 2026 Direct Coms Co., Ltd. All rights reserved.
          </p>
        </div>
      </div>

      <div className={`${shouldHideMobileTabletFooter ? 'hidden lg:block' : 'hidden md:block'} px-5 md:px-6 py-12 md:py-14 max-w-[1200px] mx-auto`}>
        <div className="grid grid-cols-1 sm:grid-cols-[1.3fr_1fr_1fr] gap-8 md:gap-10">
          <div>
            <Link to="/" className="flex items-center gap-2 mb-3 cursor-pointer">
              <span className="text-[17px] font-extrabold tracking-[-0.03em] text-[#17171A]">
                <img src='/resources/images/directwedding-logo.svg' style={{height: 40}} />
              </span>
            </Link>
            <p className="text-[13px] leading-[1.7] text-[rgba(46,47,51,0.61)]">
              다이렉트결혼준비 카페의 실제 후기와 사진을 바탕으로
              <br className="hidden md:block" />
              예복·예물·한복 인증업체를 비교할 수 있도록 정리합니다.
            </p>
            <div className="mt-5 space-y-1.5 text-[12px] leading-[1.7] text-[rgba(46,47,51,0.50)]">
              <p className="m-0">(주)다이렉트컴즈</p>
              <p className="m-0">서울특별시 강남구 도산대로 221 동남빌딩 8층</p>
              <p className="m-0">8F Dongnam Bldg, 221 Dosandae-ro, Gangnam, Seoul, Republic of Korea</p>
              <p className="m-0">
                사업자등록번호 261-81-13735
                <span className="mx-2 text-[rgba(55,56,60,0.22)]">|</span>
                대표전화 1666-8639
                <span className="mx-2 text-[rgba(55,56,60,0.22)]">|</span>
                팩스 02-547-4392
              </p>
            </div>
          </div>

          <div>
            <h4 className="mb-3 text-[13px] font-bold tracking-[0.08em] text-[#17171A]">카테고리</h4>
            <div className="flex flex-col gap-2.5">
              <Link to={LIST_PATHS.SUIT} className="text-[13px] text-[rgba(46,47,51,0.61)] hover:text-[#17171A] transition-colors whitespace-nowrap cursor-pointer">
                예복
              </Link>
              <Link to={LIST_PATHS.JEWELRY} className="text-[13px] text-[rgba(46,47,51,0.61)] hover:text-[#17171A] transition-colors whitespace-nowrap cursor-pointer">
                예물
              </Link>
              <Link to={LIST_PATHS.HANBOK} className="text-[13px] text-[rgba(46,47,51,0.61)] hover:text-[#17171A] transition-colors whitespace-nowrap cursor-pointer">
                한복
              </Link>
            </div>
          </div>

          <div>
            <h4 className="mb-3 text-[13px] font-bold tracking-[0.08em] text-[#17171A]">서비스</h4>
            <div className="flex flex-col gap-2.5">
              <Link to={GUIDE_HUB_PATH} className="text-[13px] text-[rgba(46,47,51,0.61)] hover:text-[#17171A] transition-colors whitespace-nowrap cursor-pointer">
                내 취향 찾기
              </Link>
              <Link
                to="/terms/privacy"
                className="text-[13px] text-[rgba(46,47,51,0.61)] hover:text-[#17171A] transition-colors whitespace-nowrap cursor-pointer"
              >
                개인정보처리방침
              </Link>
              <Link
                to="/terms/user-term"
                className="text-[13px] text-[rgba(46,47,51,0.61)] hover:text-[#17171A] transition-colors whitespace-nowrap cursor-pointer"
              >
                이용약관
              </Link>
            </div>
          </div>
        </div>
      </div>

      <div className={`${shouldHideMobileTabletFooter ? 'hidden lg:block' : 'hidden md:block'} border-t border-[rgba(112,115,124,0.16)]`}>
        <div className="px-5 md:px-6 py-5 max-w-[1200px] mx-auto flex flex-col sm:flex-row items-start sm:items-center justify-between gap-3">
          <span className="text-[12px] text-[rgba(55,56,60,0.4)]">
            © 2026 Direct Coms Co., Ltd. All rights reserved.
          </span>
          <div className="flex flex-wrap items-center gap-x-5 gap-y-2">
            <span className="text-[12px] text-[rgba(55,56,60,0.4)] whitespace-nowrap">실제 후기 기반 인증업체</span>
            <span className="text-[12px] text-[rgba(55,56,60,0.4)] whitespace-nowrap">정보는 업체 및 후기 데이터 기준으로 업데이트됩니다.</span>
          </div>
        </div>
      </div>
    </footer>
  );
}
